import React from "react";
import { LayoutGrid, List, Map, Building2 } from "lucide-react";

const allViewTypes = [
  { type: "grid", Icon: LayoutGrid, label: "Grid" },
  { type: "list", Icon: List, label: "List" },
  { type: "map", Icon: Map, label: "Map" },
  { type: "floorplan", Icon: Building2, label: "Floor Plan" },
];

const ViewToggle = ({ activeView, onViewChange, availableViews = ["grid", "list", "map"] }) => {
  const viewTypes = allViewTypes.filter(view => availableViews.includes(view.type));

  return (
    <div className="inline-flex bg-gray-200 rounded-md w-full sm:w-auto">
      {viewTypes.map(({ type, Icon, label }) => (
        <button
          key={type}
          onClick={() => onViewChange(type)}
          className={`flex items-center justify-center p-2 flex-1 sm:flex-none transition-all duration-200 ${
            activeView === type ? "bg-black text-white shadow-sm" : "text-black hover:bg-gray-300"
          }`}
          title={label}
        >
          <Icon className="w-4 h-4" />
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
